import { Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export const EntryContent = styled('div')(({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(2.5),
    textAlign: 'start',
    width: '100%',
    '& .MuiAlert-message': {
        textAlign: 'start',
        width: '100%',
    },
}));

export const EntryDialogHeader = styled('span')(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
}));

export const EntryHeaderIcon = styled(WhatsAppIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
    flex: '0 0 auto',
    fontSize: theme.typography.pxToRem(48),
    [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(34),
    },
}));

export const EntryHeaderTitle = styled('span')({
    display: 'block',
    fontSize: 'clamp(0.95rem, 4.5vw, 1.5rem)',
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
});

export const EntrySubtitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
}));

export const EntryIdentityFlow = styled('div')(({ theme }) => ({
    margin: '0 auto',
    maxWidth: theme.spacing(70),
    width: '100%',
}));

export const EntryIdentityCard = styled('div')(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: alpha(theme.palette.grey[100], 0.72),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1.5),
    display: 'flex',
    gap: theme.spacing(2),
    minHeight: theme.spacing(12),
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(1),
        minHeight: theme.spacing(10),
        padding: theme.spacing(1.25),
    },
}));

export const EntryIdentityIcon = styled('span', {
    shouldForwardProp: prop => prop !== '$account',
})<{ $account?: boolean }>(({ theme, $account }) => ({
    alignItems: 'center',
    backgroundColor: $account
        ? theme.palette.grey[200]
        : alpha(theme.palette.primary.main, 0.09),
    borderRadius: theme.spacing(1.25),
    color: $account ? theme.palette.text.secondary : theme.palette.primary.main,
    display: 'inline-flex',
    flex: '0 0 auto',
    height: theme.spacing(8),
    justifyContent: 'center',
    width: theme.spacing(8),
    '& .MuiSvgIcon-root': {
        fontSize: theme.typography.pxToRem(42),
    },
    [theme.breakpoints.down('sm')]: {
        height: theme.spacing(5.5),
        width: theme.spacing(5.5),
        '& .MuiSvgIcon-root': {
            fontSize: theme.typography.pxToRem(28),
        },
    },
}));

export const EntryIdentityDetails = styled('div')(({ theme }) => ({
    display: 'grid',
    flex: 1,
    gap: theme.spacing(0.5),
    minWidth: 0,
}));

export const EntryIdentityLabel = styled(Typography)({
    fontWeight: 700,
    fontSize: 'clamp(0.75rem, 3.8vw, 1rem)',
    lineHeight: 1.3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const EntryIdentityValue = styled(Typography)({
    fontSize: 'clamp(0.68rem, 3.6vw, 1rem)',
    lineHeight: 1.35,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const EntryConnector = styled('div')(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    height: theme.spacing(6),
    justifyContent: 'center',
    position: 'relative',
    '&::before': {
        backgroundColor: theme.palette.divider,
        content: '""',
        height: '100%',
        position: 'absolute',
        width: 2,
    },
}));

export const EntryConnectorBadge = styled('span')(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '50%',
    color: theme.palette.primary.main,
    display: 'inline-flex',
    height: theme.spacing(4.5),
    justifyContent: 'center',
    position: 'relative',
    width: theme.spacing(4.5),
    zIndex: 1,
}));

export const EntrySecurityNote = styled('div')(({ theme }) => ({
    alignItems: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
    textAlign: 'center',
    '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(0.75),
        '& .MuiTypography-root': {
            fontSize: theme.typography.pxToRem(13),
            lineHeight: 1.45,
        },
    },
}));

export const EntryActions = styled('div')(({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(1),
    margin: '0 auto',
    maxWidth: theme.spacing(70),
    width: '100%',
}));

export const EntryLoading = styled('div')(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: theme.spacing(12),
}));
